/**
 * Dependencies
 */
import Vue from 'vue'
import { getState } from './state'

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
const RESET_STATE = state => {
    let originalState = getState()
    for (let prop in originalState) {
        Vue.set(state, prop, originalState[prop])
    }
}

/**
 * Set the data state
 *
 * @param  {Object} state
 * @param  {Array} data
 * @return {Void}
 */
const SET_DATA = (state, data) => {
    state.data = data
}

/**
 * Set the state error
 *
 * @param  {Object} state
 * @param  {String|Promise} error
 * @return {Void}
 */
const SET_ERRORS = (state, errors) => {
    state.errors = errors
}

const RESET_ERRORS = state => {
    state.errors = []
}

/**
 * Add a schedule to the dataset
 *
 * @param  {Objcet} state
 * @param  {Object} item
 * @return {Void}
 */
const ADD_DATA = (state, item) => {
    state.data.push(item)
}

export default {
    ADD_DATA,
    SET_DATA,
    SET_ERRORS,
    RESET_STATE,
    RESET_ERRORS
}



// WEBPACK FOOTER //
// ./src/state/modules/projects/form/lease-up-schedules/mutations.js